/** Referencia de propiedad clicable → Vista Previa. */
export default function CitaLinkReferencia({ referencia, onAbrir, color, style = {} }) {
  const ref = referencia != null ? String(referencia).trim() : "";
  if (!ref) return <span style={style}>—</span>;
  const puede = typeof onAbrir === "function";
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (puede) onAbrir();
      }}
      title={puede ? "Vista previa de la propiedad" : undefined}
      style={{
        fontSize: "inherit",
        fontWeight: 700,
        color: color || "#22c55e",
        background: "none",
        border: "none",
        padding: 0,
        cursor: puede ? "pointer" : "default",
        textDecoration: puede ? "underline" : "none",
        fontFamily: "inherit",
        ...style,
      }}
    >
      {ref}
    </button>
  );
}
